/**
 * Analyst Dialog Store
 * Zustand store to open/close the analyst contact dialog from anywhere
 */

import { create } from 'zustand';

interface AnalystDialogState {
  /** Whether the analyst dialog is open */
  isOpen: boolean;
  /** Open the dialog */
  open: () => void;
  /** Close the dialog */
  close: () => void;
}

export const useAnalystDialogStore = create<AnalystDialogState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
